import { StylesConfig } from 'react-select'

const NOOP = (): any => ({});

export default ({
  clearIndicator:      NOOP,
  container:           NOOP,
  control:             NOOP,
  dropdownIndicator:   NOOP,
  group:               NOOP,
  groupHeading:        NOOP,
  indicatorsContainer: NOOP,
  indicatorSeparator:  NOOP,
  input:               NOOP,
  loadingIndicator:    NOOP,
  loadingMessage:      NOOP,
  menu:                ({ bottom, top }) => ({ bottom, top }),
  menuList:            NOOP,
  // menuPortal: NOOP,
  multiValue:       NOOP,
  multiValueLabel:  NOOP,
  multiValueRemove: NOOP,
  noOptionsMessage: NOOP,
  option:           NOOP,
  placeholder:      NOOP,
  singleValue:      NOOP,
  valueContainer:   NOOP,

  menuPortal: ({ left, top, width }) => ({ left, top, width, }),
} as StylesConfig);
